import type { IconButtonProps } from '@mui/material';
import { styled, IconButton } from '@mui/material';
import React, { forwardRef } from 'react';
const Host = styled(IconButton)<{
  size: string;
}>`
  ${({
  size
}) => {
  switch (size) {
    case 'small':
      return `
        padding: 7px;
        `;
    case 'large':
      return `
          padding: 14px;
        `;
    default:
      return `
        padding: 10px;
        `;
  }
}}

  &:hover {
    svg {
      color: inherit !important;
    }
  }
`;
const Icon = styled('span')<{
  size: string;
}>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${({
  size
}) => {
  switch (size) {
    case 'small':
      return `
          height: 16px;
          width: 16px;
        `;
    case 'large':
      return `
          height: 24px;
          width: 24px;
        `;
    default:
      return `
          height: 20px;
          width: 20px;
        `;
  }
}}
  svg {
    width: 100%;
    height: auto;
  }
`;
interface TixIconButtonProps extends IconButtonProps {
  children: React.ReactNode;
  variant?: 'contained' | 'outlined';
  color?: 'primary' | 'secondary' | 'monochrome';
  size?: 'small' | 'medium' | 'large';
}

/**
 * @deprecated TixIconButton is deprecated. Use TixlyIconButton from '@tix-ticketing/ui-components' instead.
 */
export const TixIconButton = forwardRef<HTMLButtonElement, TixIconButtonProps>(function TixIconButton({
  children,
  color = 'primary',
  size = 'medium',
  variant = 'contained',
  ...rest
}, ref) {
  return <Host color={color} size={size} ref={ref} sx={theme => {
    const extra = (rest.sx ?? {}) as any;
    if (variant === 'outlined') {
      return {
        ...extra,
        '&:hover': {
          color: theme.palette[color].contrastText,
          backgroundColor: theme.palette.action.hover
        },
        backgroundColor: 'transparent',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette[color].light,
        color: theme.palette.text.primary,
        borderRadius: theme.shape.borderRadius,
        '&[disabled]': {
          backgroundColor: theme.palette.action.disabledBackground,
          borderStyle: 'solid',
          borderColor: 'transparent'
        }
      };
    }
    return {
      ...extra,
      borderWidth: 1,
      transitionProperty: 'background-color, border-color',
      '&:hover': {
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].dark
      },
      '&[disabled]': {
        backgroundColor: theme.palette.action.disabledBackground,
        borderStyle: 'solid',
        borderColor: 'transparent'
      },
      backgroundColor: theme.palette[color].main,
      color: theme.palette[color].contrastText,
      borderRadius: theme.shape.borderRadius
    };
  }} {...rest}>
        <Icon size={size}>{children}</Icon>
      </Host>;
});